<!-- SOCIAL MEDIA SECTION - STARTS -->
<section class="social-section">
    <div class="container-xxl" data-aos="fade-up" data-aos-duration="600" data-aos-once="true">
        <ul class="nav nav-pills mb-4" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
                <button class="nav-link active screen-reader" [attr.title]="language=='English'?'Social Media':'सोशल मीडिया'" id="social" data-bs-toggle="pill" data-bs-target="#social-tab" type="button"
                role="tab" aria-controls="pills-home" aria-selected="true">{{'SocialMedia' | translate}}</button>
            </li>
            <li class="nav-item" role="presentation">
                <button class="nav-link screen-reader" (click)="getGalleryCat()" [attr.title]="language=='English'?'Photo Gallery':'फोटो गैलरी'" id="photo-gallery-tab" data-bs-toggle="pill"
                    data-bs-target="#photo-gallery" type="button" role="tab" aria-controls="photo-gallery"
                    aria-selected="false">{{'Photo' | translate}} <span>{{'Gallery' | translate}}</span></button>
            </li> 
            <li class="nav-item" role="presentation">
                <button class="nav-link screen-reader" (click)="getVideoCat()" [attr.title]="language=='English'?'Video Gallery':'वीडियो गैलरी'" id="video-tab" data-bs-toggle="pill" data-bs-target="#video" type="button"
                    role="tab" aria-controls="video" aria-selected="false">{{'Video' | translate}} <span>{{'Gallery' | translate}}</span></button>
            </li>
 
        </ul>
        <div class="tab-content mt-2 mt-lg-2" id="pills-tabContent">

            <div class="tab-pane fade show active" id="social-tab" role="tabpanel" aria-labelledby="social" tabindex="0">
                <div class="row">
                    <div class="col-xxl-7 col-xl-6 col-md-6 col-sm-12 px-3 mb-3 mb-lg-0">
                        <div class="social-box-area screen-reader">
                            <iframe src="https://syndication.twitter.com/srv/timeline-profile/screen-name/FCI_India?dnt=false&embedId=twitter-widget-0&frame=false&hideBorder=false&hideFooter=false&hideHeader=false&hideScrollBar=false&lang=en&maxHeight=400px" height="400" width="800" style="border:none;overflow:hidden"  scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                        </div>
                    </div>
                    <div class="col-xxl-5 col-xl-6 col-md-6 col-sm-12 px-3">
                        <div class="social-box-area screen-reader">
                            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFoodCorporation&tabs=timeline&width=500&height=400&small_header=true&hide_cover=true&show_facepile=false&appId" height="400" width="500" style="border:none;overflow:hidden" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Photo Tab Area -->
            <div class="tab-pane fade" id="photo-gallery" role="tabpanel" aria-labelledby="photo-gallery" tabindex="0">
                <div class="info-box"> 
                    <div class="gallerydetails">

                        <div class="row gallerydetails-image-area" id="gallery-container">
                            <div *ngFor="let items of galleryCat; let i=index;" [class]="designArr[i]" 
                            [attr.data-responsive]="this.imageUrl+items.featuredImage"
                            [attr.data-src]="this.imageUrl+items.featuredImage"  (click)="viewDetails(items.id,'gallery')"  >
                                <a href="javascript:void(0);" [attr.title]="language=='English'?'View Photo':'फ़ोटो देखें'">
                                    <img alt="FCI - image" class="gallerydetails-image" [src]="this.imageUrl+items.featuredImage">
                                    <div class="middle">
                                        <div class="text">
                                              <i class="img-caption bi bi-images"></i>
                                        </div>
                                    </div>
                                    <figcaption class="screen-reader">{{htmldecode(language == 'English' ? items.category: items.categoryInHindi)}}
                                    </figcaption>
                                </a>
                            </div>
                    </div>
                    
                        <div class="text-center me-4 my-2">
                            <a *ngIf="totalgalleryCat > 0" routerLink="../gallerycategory" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{'ViewMore' | translate}}</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Video Tab Area -->
            <div class="tab-pane fade" id="video" role="tabpanel" aria-labelledby="video-tab" tabindex="0">
                <div class="info-box">
                    <div class="videodetails">
                        
                        <div class="row videodetails-image-area" id="video-container">
                            <div *ngFor="let items of VideoCat; let i=index;" [class]="designArr[i]" 
                            [attr.data-responsive]="this.imageUrl+items.featuredImage"
                            [attr.data-src]="this.imageUrl+items.featuredImage"  (click)="viewDetails(items.id,'videogallery')"  >
                                <a href="javascript:void(0);" [attr.title]="language=='English'?'View Video Category':'वीडियो श्रेणी देखें'">
                                    <img alt="FCI - image" class="videodetails-image" [src]="this.imageUrl+items.featuredImage">
                                    <div class="middle">
                                        <div class="text">
                                              <i class="img-caption bi bi-images"></i>
                                        </div>
                                    </div>
                                    <figcaption class="screen-reader">{{htmldecode(language == 'English' ? items.category: items.categoryInHindi)}}
                                    </figcaption>
                                </a>
                            </div>
                    </div>

                    
                        <div class="text-center me-4 my-2">
                            <a *ngIf="totalVideoCat > 0" routerLink="../videocategory" [attr.title]="language=='English'?'Click to view more':'अधिक देखने के लिए क्लिक करें'" class="btn btn-orange-outline screen-reader">{{'ViewMore' | translate}}</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>
<!-- SOCIAL MEDIA SECTION - ENDS -->